import React from 'react';
import { useParams } from 'react-router-dom';
import { Card, Text, Button, Group } from '@mantine/core';
import api, { Book } from '../services/api';

function BookDetails() {
  const { id } = useParams<{ id: string }>();
  const [book, setBook] = React.useState<Book | null>(null);

  React.useEffect(() => {
    const fetchBookDetails = async () => {
      try {
        const data = await api.books.getById(id!);
        setBook(data);
      } catch (error) {
        console.error('Ошибка при загрузке деталей книги:', error);
      }
    };
    fetchBookDetails();
  }, [id]);

  const handleReserve = async () => {
    if (!book) return;
    
    try {
      if (!api.telegram.isInitialized()) {
        throw new Error('Приложение должно быть открыто в Telegram');
      }
      
      const user = api.telegram.getUser();
      if (!user) {
        throw new Error('Пожалуйста, откройте приложение через Telegram');
      }
      
      await api.books.reserve(book.id, user.id);
      api.telegram.showAlert('Книга успешно забронирована!');
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Ошибка при бронировании';
      api.telegram.showAlert(message);
    }
  };

  if (!book) {
    return <Text>Загрузка...</Text>;
  }

  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder>
      <Group justify="space-between" mb="xs">
        <Text fw={500}>{book.title}</Text>
      </Group>
      <Text size="sm" c="dimmed">
        {book.description}
      </Text>
      <Button
        variant="light"
        color={book.available ? "blue" : "gray"}
        fullWidth
        mt="md"
        radius="md"
        onClick={handleReserve}
        disabled={!book.available}
      >
        {book.available ? 'Забронировать' : 'Недоступно'}
      </Button>
    </Card>
  );
}

export default BookDetails; 